import React from 'react';
import { ModalProps } from './App';
import './modal.css'; // Add specific styling for the modal


const Modal: React.FC<ModalProps> = ({ isOpen, onClose, content }) => {
  if (!isOpen || !content) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content">
      <div >
        <h2>{content.nameEn}</h2>
        <div className='modal-description'>{content.descriptionEn}</div><br/>
        <button className="modal-close-button" onClick={onClose}>Close</button>
      </div>
    </div>
    </div>
  );
};

export default Modal;